import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { ResaleListingProvider } from '../../hooks/contexts/resale-listing.context';
import { ResaleEventProvider } from '../../hooks/contexts/resaleEvent.context';
import FixedBarTheme from '../Header/AppBar/FixedBarTheme';
import { ResaleListingAppBar } from '../Header/ResaleListingAppBar';
import * as Style from './layout.styles';

export const ResaleListingLayout: FC = () => {
  return (
    <ResaleListingProvider>
      <ResaleEventProvider>
        <Style.Layout id="layout-app" data-testid="layout-app">
          <Style.Header id="header-app" data-testid="header-app">
            <FixedBarTheme />
            <Style.Container>
              <ResaleListingAppBar />
            </Style.Container>
          </Style.Header>
          <Style.Container>
            <Style.ContainerChild>
              <Outlet />
            </Style.ContainerChild>
          </Style.Container>
        </Style.Layout>
      </ResaleEventProvider>
    </ResaleListingProvider>
  );
};
